import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BaseService, NavigateMode, OwnValidators } from 'projects/shared/src/public-api';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class CustomerService extends BaseService {
   httpOptions = {
    headers: new HttpHeaders({
      'Content-Type':  'application/json',
      Authorization: 'my-auth-token'
    })
  };
  constructor(private httpClient: HttpClient) {
    super(httpClient);
  }
  put(id: number, customer: any) {
    return this.httpClient.put('/Customers/' + id, { Entity: customer })
  }
  getCustomers(request: { listQuery: any, status: number, projectIds: number[], groupName: string }): Observable<any> {
    return this.httpClient.post('/Customers/getCustomers', request);
  }
  getNumberNewJoinedCustomers() {
    return this.get('/Customers/getNumberNewJoinedCustomers', false)
  }
  getCustomer(id: number) {
    return this.httpClient.get<{}>('/Customers/' + id);
  }
  getAllCompanyGroups(addNoGroupItem=true): Observable<any> {
    return this.httpClient.get('/Customers/allCompanyGroups/' + addNoGroupItem);
  }
  getCustomerOverview(id: number) {
    return this.httpClient.get<{}>('/Customers/customerOverview/' + id);
  }
  getPrevOrNext(customerId: string, mode: NavigateMode): Observable<any> {
    return this.httpClient.get(`/Customers/getPrevOrNext/${customerId}/${mode}`);
  }
  getCustomerObligations(id: number): Observable<any> {
    return this.httpClient.get('/Customers/getCustomerObligations/' + id);
  }
  getCustomerTransactions(customerId: number, obligationId: number): Observable<any> {
    return this.httpClient.get('/Customers/getCustomerObligations/' + customerId + '/' + obligationId);
  }
  getAllMatchUsers(customer: any): Observable<any> {
    return this.httpClient.post('/Customers/getMatchUsers', customer);
  }
  loadMasavFiles(): Observable<any> {
    return this.httpClient.get('/Masav/loadMasavFiles');
  }
  getSearchList(request: any): Observable<any> {
    return this.httpClient.post('/Customers/getSearchList', request);
  }
  getActiveClientsList(request: any): Observable<any> {
    return this.httpClient.post('/Customers/getActiveClientsList', request);
  }
  checkClientActivate(customerId: number): Observable<any> {
    return this.httpClient.get('/Customers/checkClientActivate/' + customerId);
  }
  checkClientIsNotDeleted(customerId: number): Observable<any> {
    return this.httpClient.get('/Customers/checkClientIsNotDeleted/' + customerId);
  }
  delete(id: number[]): Observable<any> {
    return this.httpClient.delete('/Customers/' + id);
  }
  deleteCustomers(ids: number[]) {
    return this.httpClient.delete('/Customers/deleteCustomers' + ids);
  }
  deleteList(ids: number[]): Observable<any> {
    return this.httpClient.post('/Customers/deleteList', ids);
  }
  reactivate(id: number) {
    return this.httpClient.put('/Customers/reactivate', { Entity: id });
  }
  updateFavorite(id: number) {
    return this.httpClient.put('/Customers/updateFavorite', { Entity: id });
  }
  saveCustomer(customer: any) {
    return this.httpClient.post('/Customers/save', { Entity: customer });
  }
  export(request: { exportGetDataParams: { listQuery: any, status: number, projectIds: number[] }, fileName: string }): Observable<any> {
    return this.httpClient.post('/Customers/export', request, { responseType: "blob", headers: { 'Accept': 'application/octet-stream' } })
  }

  exportCustomersChanges(fileName): Observable<any> {
    return this.httpClient.get('/Customers/exportCustomersChanges', { responseType: "blob", headers: { 'Accept': 'application/octet-stream' } })
  }
  getSameCustomers(request: { listQuery: any, tz: boolean, phone: boolean, mail: boolean }): Observable<any> {
    return this.httpClient.post('/Customers/getSameCustomers', request);
  }
  getSameCustomersToParticularCustomer(customerId: number): Observable<any> {
    return this.httpClient.get('/Customers/getSameCustomersToParticularCustomer/' + customerId);
  }
  getSameCustomersToCertainValue(request: { listQuery: any, sameCustomersParam: any }): Observable<any> {
    return this.httpClient.post('/Customers/getSameCustomersToCertainValue', request)
  }
  mergeCustomers(request): Observable<any> {
    return this.httpClient.post('/Customers/mergeCustomers', request);
  }
  sendCustomerActions(request): Observable<any> {
    return this.httpClient.post('/Customers/sendCustomerActions',request);
  } 
  checkCustomersFile(request): Observable<any> {
    return this.httpClient.post('/Customers/checkCustomersFile', { entities: request });
  }
  uploadCustomersFile(request): Observable<any> {
    return this.httpClient.post('/Customers/uploadCustomersFile', { entities: request });
  }
  loadForm(data: any, params: any) {
    return new FormGroup({
      id: new FormControl(params ? params.customerIdentity : null),
      Ref: new FormControl({ value: data.ref, disabled: true }),
      Tz: new FormControl(data.tz, [(control: FormControl) => OwnValidators.multipleValidator(control, [OwnValidators.israeliIdentityValidator, OwnValidators.validNumAssociation], false)]),
      FirstName: new FormControl(data.firstName, OwnValidators.simpleChars),
      LastName: new FormControl(data.lastName, [Validators.required, OwnValidators.simpleChars]),
      Phone1: new FormControl(data.phone1, [Validators.minLength(7), OwnValidators.validPhone]),
      Phone2: new FormControl(data.phone2, [Validators.minLength(7), OwnValidators.validPhone]), // - only numbers
      InsertDate: new FormControl({ value: data.insertDate ? new Date(data.insertDate) : new Date(), disabled: true }),
      Mail: new FormControl(data.mail, OwnValidators.validMail),
      Address: new FormControl(data.address),
      NumHouse: new FormControl(data.numHouse, Validators.pattern("^[0-9]*$")), // - only numbers
      Entrance: new FormControl(data.entrance),
      Floor: new FormControl(data.floor),
      ApartmentNumber: new FormControl(data.apartmentNumber),
      City: new FormControl(data.city),
      Country: new FormControl(data.country),
      Group: new FormControl(data.group),
      Fax: new FormControl(data.fax),
      ApiIdentity: new FormControl(data.apiIdentity),
      Favorite: new FormControl(data.favorite),
      Comment: new FormControl(data.comment),
      status: new FormControl(data.status)
    });
  }


}


